/**
 * Leads → Worker /lead (API AC côté serveur). Fallback proc.php si pas de bridge.
 * Jamais de clé API ici.
 */
(() => {
  const parseConfig = () => {
    const node = document.getElementById('gb-ac-config');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  };

  const config = parseConfig();
  const bridge = () => String((config && config.bridgeUrl) || '').replace(/\/+$/, '');

  const ready = () =>
    Boolean(
      config &&
        config.enabled &&
        (bridge() || (config.postUrl && (config.f || config.u)))
    );

  const append = (data, key, value) => {
    if (!key || value == null || value === '') return;
    data.append(key, String(value));
  };

  const postBridge = async (payload) => {
    const res = await fetch(`${bridge()}/lead`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
    const data = await res.json().catch(() => ({}));
    return { ok: res.ok && data.ok !== false, data };
  };

  const postForm = async (payload) => {
    const data = new FormData();
    const id = String(config.f || config.u);
    data.append('u', String(config.u || id));
    data.append('f', id);
    data.append('s', '');
    data.append('c', '0');
    data.append('m', '0');
    data.append('act', 'sub');
    data.append('v', String(config.v || '2'));
    if (config.or) data.append('or', String(config.or));

    append(data, 'email', payload.email);
    append(data, 'fullname', payload.fullname);
    append(data, 'firstname', payload.firstname);
    append(data, 'lastname', payload.lastname);
    append(data, 'phone', payload.phone);
    append(data, config.fields && config.fields.source, payload.source);
    append(data, config.fields && config.fields.vote, payload.vote);
    append(data, config.fields && config.fields.topic, payload.topic);
    append(data, config.fields && config.fields.business, payload.business);
    append(data, config.fields && config.fields.message, payload.message);

    const send = fetch(config.postUrl, { method: 'POST', body: data, mode: 'no-cors', keepalive: true });
    const timeout = new Promise((resolve) => {
      window.setTimeout(() => resolve({ ok: false, timeout: true }), 2500);
    });
    await Promise.race([send, timeout]);
    return { ok: true };
  };

  window.gbAcSubmit = async (payload) => {
    if (!ready()) return { ok: false, skipped: true };
    if (bridge()) {
      try {
        return await postBridge(payload);
      } catch (err) {
        if (config.postUrl && (config.f || config.u)) return postForm(payload);
        throw err;
      }
    }
    return postForm(payload);
  };

  window.gbAcReady = ready;
})();
